/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
    init: (app, Swiper) => {

        /*
        |
        | Constants
        |------------
        */

        /*
		|
		| Swiper (Testimonial)
		|-----------
		*/
		const
            $swiperTestimonial = $('[data-slider="testimonial"]')
        ;

        if ( $swiperTestimonial.length ) {
            
            const swiperTestimonial = new Swiper( $swiperTestimonial.get(0), {
                // Optional parameters
                // direction: 'vertical',
                // loop: true,
                autoHeight: true,
            
                // If we need pagination
                // pagination: {
                //   el: '.swiper-pagination',
                // },
            
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            
                // And if we need scrollbar
                // scrollbar: {
                //   el: '.swiper-scrollbar',
                // },
            });

        }

    }
}
